export enum LinkMenuBarEnum {
    baseURL,
    newsURL,
    storyURL,
    blogURL,
    courseURL,
    outsiteURL
  }